import clsx from "clsx";
import { ColorProps, createColorClasses } from "@/theme/colors";
import "./Divider.scss";

type DividerProps = Pick<ColorProps, "bg"> & {
  direction?: "horizontal" | "vertical";
  className?: string;
};

export const Divider = ({
  direction = "horizontal",
  bg = "white",
  className,
}: DividerProps) => {
  const colorClass = createColorClasses({ bg });

  return (
    <div
      className={clsx(
        direction === "horizontal" ? "ui-horizontal" : "ui-vertical",
        colorClass,
        className,
      )}
    />
  );
};
